/**
* this is the component for the application button with icon (if provided)
*
* Created by Tom on 25/5/17
*/

import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

// style import
import './style.scss'

const AppButton = ({buttonText, size, color, onClick}) => {

    // class expression
    let dynClass = cx('app-button', 'app-button--' + size, 'app-button--' + color)

    return (
        <div className={dynClass} onClick={onClick}>
          {buttonText}
        </div>
    )
}

// define the prop types
AppButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    size: PropTypes.string
}

export default AppButton



// WEBPACK FOOTER //
// ./src/components/AppButton/index.js